import { NgModule } from '@angular/core';
import { AppendViewContainerRefDirective } from './append-view-container-ref-directive';


export class MdlCommonsModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [],
  exports: [AppendViewContainerRefDirective],
  declarations: [AppendViewContainerRefDirective],
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
